<template>
    <div class="mt-4 mb-4
        sm:-ml-4 sm:-mr-4
        md:-ml-6 md:-mr-6
    "
    >
        <div class="flex items-center">
            <hr class="flex-grow border-t border-gray-300">
        </div>
    </div>
</template>

<script>

export default {

}
</script>